<template>
    <div class="flex flex-col flex-1 w-full border-b border-gray-400 mb-8 pt-8">
        <form-row title="Description" :no_border="true" class="mb-8">
            <div class="w-full -mt-2">
                <input-text
                    class="w-full pt-3"
                    placeholder="Description"
                    :name="'tenant[' + tenant.id + '][long_term_obligations]'"
                    v-model="long_term_obligations"
                    :read_only="read_only"
                />
            </div>
        </form-row>

        <form-row title="Amount" :no_border="true" class="mb-8">
            <div class="w-40 -mt-2">
                <input-money
                    class="w-full pt-3"
                    :name="'tenant[' + tenant.id + '][long_term_obligations_amount]'"
                    v-model="long_term_obligations_amount"
                    :read_only="read_only"
                />
            </div>
        </form-row>

        <form-row title="Is there a sunset date?"
            :no_border="true"
            class="mb-8"
            :label_align_top="true"
        >
            <div class="w-full -mt-2">
                <input-radio-boolean-reactive
                    :name="'tenant[' + tenant.id + '][long_term_obligations_has_sunset_date]'"
                    v-model="long_term_obligations_has_sunset_date"
                    true="Yes"
                    false="No"
                    class="pt-2"
                    :read_only="read_only"
                />

                <input-date
                    v-if="long_term_obligations_has_sunset_date"
                    class="mt-6"
                    label="Sunset Date"
                    :name="'tenant[' + tenant.id + '][long_term_obligations_sunset_date]'"
                    v-model="long_term_obligations_sunset_date"
                    :read_only="read_only"
                />
            </div>
        </form-row>
    </div>
</template>

<script>
export default {
    props: {
        read_only: { default: false },
        tenant: {},
    },

    computed: {
        total_square_feet() {
            return store.state.square_feet || null;
        },
        tenant_square_feet_percentage() {
            return this.tenant.tenant_square_feet && this.total_square_feet
                && (this.tenant.tenant_square_feet <= this.total_square_feet)
                    ? Math.round(parseInt(this.tenant.tenant_square_feet) / parseInt(this.total_square_feet) * 100)
                    : null;
        },
        long_term_obligations: {
            get() {
                return this.tenant.long_term_obligations;
            },
            set(value) {
                this.tenant.long_term_obligations = value;
            },
        },
        long_term_obligations_amount: {
            get() {
                return this.tenant.long_term_obligations_amount;
            },
            set(value) {
                this.tenant.long_term_obligations_amount = value;
            },
        },
        long_term_obligations_has_sunset_date: {
            get() {
                return this.tenant.long_term_obligations_has_sunset_date ? 1 : 0;
            },
            set(value) {
                this.tenant.long_term_obligations_has_sunset_date = value;
            },
        },
        long_term_obligations_sunset_date: {
            get() {
                return this.tenant.long_term_obligations_sunset_date;
            },
            set(value) {
                this.tenant.long_term_obligations_sunset_date = value;
            },
        },
    },
}
</script>
